/**
 * Client-scoped access names. Keep them in sync with ClientPermissions and ClientRoles in the API
 * (I95Dev.Cloud.Common/Helpers/ClientRoles.cs). The API enforces these; the UI only shows or hides features.
 */
export const CLIENT_PERMISSION = {
    USER_READ: 'client.user.read',
    USER_INVITE: 'client.user.invite',
    USER_CHANGE_STATUS: 'client.user.change-status',
    USER_ASSIGN_ROLE: 'client.user.assign-role',
    USER_RESET_PASSWORD: 'client.user.reset-password',
    TOKEN_READ: 'credential.token.read',
    TOKEN_ROTATE: 'credential.token.rotate',
    CONNECTION_CREATE: 'connection.create',
    CONFIG_WRITE: 'connection.config.write',
    CONFIG_REVEAL_SECRETS: 'connection.config.reveal-secrets',
    MAPPING_WRITE: 'connection.mapping.write',
    ENTITIES_MANAGE: 'connection.entities.manage',
    SYNC_RETRY: 'sync.retry'
}

export const CLIENT_ROLE = {
    OWNER: 'Owner',
    ADMIN: 'Admin',
    INTEGRATION_MANAGER: 'IntegrationManager',
    OPERATOR: 'Operator',
    VIEWER: 'Viewer'
}

// Owner and Admin can only be granted by someone allowed to assign roles.
export const PRIVILEGED_ROLES = [CLIENT_ROLE.OWNER, CLIENT_ROLE.ADMIN]

const ROLE_SEPARATOR = ','

/** Splits the API's role value (for example "Admin,Operator") into its roles. */
export const splitClientRoles = (role) => String(role || '')
    .split(ROLE_SEPARATOR)
    .map((value) => value.trim())
    .filter(Boolean)

/** Builds the API's role value, de-duplicated in the order the API stores roles. */
export const joinClientRoles = (roles) => Object.values(CLIENT_ROLE)
    .filter((role) => roles.includes(role))
    .join(ROLE_SEPARATOR)
